import { MoneyScaled } from '../types';

export const removeScaleFromMoney = (scaledMoney: MoneyScaled): number => {
  const scale = Math.pow(10, scaledMoney.scale);
  return scaledMoney.amount / scale;
};
